var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7449 2.80344C11.632 2.61519 11.4285 2.5 11.209 2.5H5.16673C4.68092 2.5 4.38085 3.02998 4.6308 3.44656L11.3808 14.6966C11.4938 14.8848 11.6972 15 11.9167 15H17.959C18.4448 15 18.7449 14.47 18.4949 14.0534L11.7449 2.80344Z",
    fill: "#C52229"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.209 1.875H5.16674C4.19513 1.875 3.59499 2.93496 4.09488 3.76812L10.8449 15.0181C11.0708 15.3946 11.4777 15.625 11.9167 15.625H17.959C18.9306 15.625 19.5308 14.565 19.0309 13.7319L12.2809 2.48188C12.055 2.10537 11.6481 1.875 11.209 1.875ZM11.209 2.5C11.4285 2.5 11.632 2.61519 11.7449 2.80344L18.4949 14.0534C18.7449 14.47 18.4448 15 17.959 15H11.9167C11.6972 15 11.4938 14.8848 11.3808 14.6966L4.63081 3.44656C4.38087 3.02998 4.68094 2.5 5.16674 2.5H11.209Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2558 2.80344C18.3688 2.61519 18.5722 2.5 18.7917 2.5H24.834C25.3198 2.5 25.6199 3.02998 25.3699 3.44656L18.6199 14.6966C18.507 14.8848 18.3035 15 18.084 15H12.0417C11.5559 15 11.2559 14.47 11.5058 14.0534L18.2558 2.80344Z",
    fill: "#F1333B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7917 1.875H24.834C25.8056 1.875 26.4057 2.93496 25.9059 3.76812L19.1559 15.0181C18.9299 15.3946 18.5231 15.625 18.084 15.625H12.0417C11.0701 15.625 10.47 14.565 10.9699 13.7319L17.7199 2.48188C17.9458 2.10537 18.3526 1.875 18.7917 1.875ZM18.7917 2.5C18.5722 2.5 18.3687 2.61519 18.2558 2.80344L11.5058 14.0534C11.2558 14.47 11.5559 15 12.0417 15H18.084C18.3035 15 18.507 14.8848 18.6199 14.6966L25.3699 3.44656C25.6199 3.02998 25.3198 2.5 24.834 2.5H18.7917Z",
    fill: "#9B0F15"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9072 2.8548C19.0565 2.94147 19.1072 3.13272 19.0205 3.28197L16.208 8.12572C16.1214 8.27497 15.9301 8.32571 15.7809 8.23905C15.6316 8.15238 15.5809 7.96114 15.6675 7.81188L18.48 2.96813C18.5667 2.81888 18.758 2.76814 18.9072 2.8548Z",
    fill: "#FE666D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.15578 2.8548C5.00652 2.94147 4.95578 3.13272 5.04245 3.28197L7.85495 8.12572C7.94161 8.27497 8.13286 8.32571 8.28211 8.23905C8.43136 8.15238 8.4821 7.96114 8.39544 7.81188L5.58294 2.96813C5.49628 2.81888 5.30503 2.76814 5.15578 2.8548Z",
    fill: "#DF3840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.094 3.52539C11.094 3.74652 10.9191 3.92578 10.7034 3.92578C10.4876 3.92578 10.3127 3.74652 10.3127 3.52539C10.3127 3.30426 10.4876 3.125 10.7034 3.125C10.9191 3.125 11.094 3.30426 11.094 3.52539Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72204 3.62305C9.72204 3.89811 9.5045 4.12109 9.23614 4.12109C8.96779 4.12109 8.75024 3.89811 8.75024 3.62305C8.75024 3.34798 8.96779 3.125 9.23614 3.125C9.5045 3.125 9.72204 3.34798 9.72204 3.62305Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9379 5.04883C10.9379 5.32389 10.7203 5.54688 10.452 5.54688C10.1836 5.54688 9.96606 5.32389 9.96606 5.04883C9.96606 4.77376 10.1836 4.55078 10.452 4.55078C10.7203 4.55078 10.9379 4.77376 10.9379 5.04883Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0486 4.37012C12.0486 4.50765 11.9399 4.61914 11.8057 4.61914C11.6715 4.61914 11.5627 4.50765 11.5627 4.37012C11.5627 4.23259 11.6715 4.12109 11.8057 4.12109C11.9399 4.12109 12.0486 4.23259 12.0486 4.37012Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47906 4.7998C9.47906 4.93734 9.37029 5.04883 9.23611 5.04883C9.10194 5.04883 8.99316 4.93734 8.99316 4.7998C8.99316 4.66227 9.10194 4.55078 9.23611 4.55078C9.37029 4.55078 9.47906 4.66227 9.47906 4.7998Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1253 3.27637C8.1253 3.4139 8.01653 3.52539 7.88235 3.52539C7.74818 3.52539 7.6394 3.4139 7.6394 3.27637C7.6394 3.13884 7.74818 3.02734 7.88235 3.02734C8.01653 3.02734 8.1253 3.13884 8.1253 3.27637Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8057 6.1084C11.8057 6.24593 11.697 6.35742 11.5628 6.35742C11.4286 6.35742 11.3198 6.24593 11.3198 6.1084C11.3198 5.97087 11.4286 5.85938 11.5628 5.85938C11.697 5.85938 11.8057 5.97087 11.8057 6.1084Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5557 6.35742C10.5557 6.49495 10.447 6.60645 10.3128 6.60645C10.1786 6.60645 10.0698 6.49495 10.0698 6.35742C10.0698 6.21989 10.1786 6.1084 10.3128 6.1084C10.447 6.1084 10.5557 6.21989 10.5557 6.35742Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9785 5.4541C12.9785 5.67793 12.8015 5.85938 12.5831 5.85938C12.3648 5.85938 12.1877 5.67793 12.1877 5.4541C12.1877 5.23028 12.3648 5.04883 12.5831 5.04883C12.8015 5.04883 12.9785 5.23028 12.9785 5.4541Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.494 6.60645C13.494 6.74398 13.3852 6.85547 13.251 6.85547C13.1168 6.85547 13.0081 6.74398 13.0081 6.60645C13.0081 6.46891 13.1168 6.35742 13.251 6.35742C13.3852 6.35742 13.494 6.46891 13.494 6.60645Z",
    fill: "#AA161D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 19.0625C23.4375 23.7224 19.6599 27.5 15 27.5C10.3401 27.5 6.5625 23.7224 6.5625 19.0625C6.5625 14.4026 10.3401 10.625 15 10.625C19.6599 10.625 23.4375 14.4026 23.4375 19.0625Z",
    fill: "#FFBB0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0625 19.0625C24.0625 24.0676 20.0051 28.125 15 28.125C9.99492 28.125 5.9375 24.0676 5.9375 19.0625C5.9375 14.0574 9.99492 10 15 10C20.0051 10 24.0625 14.0574 24.0625 19.0625ZM15 27.5C19.6599 27.5 23.4375 23.7224 23.4375 19.0625C23.4375 14.4026 19.6599 10.625 15 10.625C10.3401 10.625 6.5625 14.4026 6.5625 19.0625C6.5625 23.7224 10.3401 27.5 15 27.5Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1875 19.375C7.01491 19.375 6.875 19.2351 6.875 19.0625C6.875 14.5752 10.5127 10.9375 15 10.9375C15.1726 10.9375 15.3125 11.0774 15.3125 11.25C15.3125 11.4226 15.1726 11.5625 15 11.5625C10.8579 11.5625 7.5 14.9204 7.5 19.0625C7.5 19.2351 7.36009 19.375 7.1875 19.375Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8125 18.75C22.9851 18.75 23.125 18.8899 23.125 19.0625C23.125 23.5498 19.4873 27.1875 15 27.1875C14.8274 27.1875 14.6875 27.0476 14.6875 26.875C14.6875 26.7024 14.8274 26.5625 15 26.5625C19.1421 26.5625 22.5 23.2046 22.5 19.0625C22.5 18.8899 22.6399 18.75 22.8125 18.75Z",
    fill: "#E8AA0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19.0625C21.25 22.5143 18.4518 25.3125 15 25.3125C11.5482 25.3125 8.75 22.5143 8.75 19.0625C8.75 15.6107 11.5482 12.8125 15 12.8125C18.4518 12.8125 21.25 15.6107 21.25 19.0625Z",
    fill: "#FFDD28"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.875 19.0625C21.875 22.8595 18.797 25.9375 15 25.9375C11.203 25.9375 8.125 22.8595 8.125 19.0625C8.125 15.2655 11.203 12.1875 15 12.1875C18.797 12.1875 21.875 15.2655 21.875 19.0625ZM15 25.3125C18.4518 25.3125 21.25 22.5143 21.25 19.0625C21.25 15.6107 18.4518 12.8125 15 12.8125C11.5482 12.8125 8.75 15.6107 8.75 19.0625C8.75 22.5143 11.5482 25.3125 15 25.3125Z",
    fill: "#E89B05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24.375C17.934 24.375 20.3125 21.9965 20.3125 19.0625C20.3125 18.8899 20.4524 18.75 20.625 18.75C20.7976 18.75 20.9375 18.8899 20.9375 19.0625C20.9375 22.3417 18.2792 25 15 25C14.8274 25 14.6875 24.8601 14.6875 24.6875C14.6875 24.5149 14.8274 24.375 15 24.375Z",
    fill: "#ECC704"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13.75C12.066 13.75 9.6875 16.1285 9.6875 19.0625C9.6875 19.2351 9.54759 19.375 9.375 19.375C9.20241 19.375 9.0625 19.2351 9.0625 19.0625C9.0625 15.7833 11.7208 13.125 15 13.125C15.1726 13.125 15.3125 13.2649 15.3125 13.4375C15.3125 13.6101 15.1726 13.75 15 13.75Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7461 21.5625H14.6877V17.4829L13.4243 17.8748V17.0142L15.6326 16.2231H15.7461V21.5625Z",
    fill: "#FFEF9C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3711 21.5625C16.3711 21.9077 16.0913 22.1875 15.7461 22.1875H14.6877C14.3426 22.1875 14.0627 21.9077 14.0627 21.5625V18.3311L13.6095 18.4717C13.4198 18.5305 13.2134 18.4957 13.0536 18.3779C12.8937 18.2601 12.7993 18.0733 12.7993 17.8748V17.0142C12.7993 16.7502 12.9651 16.5148 13.2135 16.4258L15.4218 15.6348C15.4894 15.6105 15.5607 15.5981 15.6326 15.5981H15.7461C16.0913 15.5981 16.3711 15.878 16.3711 16.2231V21.5625ZM14.6877 17.4829V21.5625H15.7461V16.2231H15.6326L13.4243 17.0142V17.8748L14.6877 17.4829Z",
    fill: "#E89B05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2697",
    x: 0,
    y: 0,
    width: 31.107,
    height: 31.107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.107,
    dy: 1.107
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.637788 0 0 0 0 0.545996 0 0 0 0 0.47948 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2697"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2697",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMedal);
export default __webpack_public_path__ + "static/media/Gold_medal.51e16c243570022983ccda3d8a2de3c1.svg";
export { ForwardRef as ReactComponent };